"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _module = _interopRequireDefault(require("./module"));
var _logger = _interopRequireDefault(require("../utils/logger"));
var PageManage = /*#__PURE__*/function () {
  function PageManage(_options, allWebpackExternals) {
    (0, _classCallCheck2["default"])(this, PageManage);
    // 所有公共的外部依赖，比如vue、antd、echart等
    this.allWebpackExternals = allWebpackExternals;
    this.webpackExternals = [];
    this.installPages = {};
  }
  (0, _createClass2["default"])(PageManage, [{
    key: "register",
    value: function register(pageId, compDependencies, webpackExternals, compFunc) {
      if (this.installPages[pageId]) return;
      var curModule = new _module["default"](pageId, null, this.allWebpackExternals);
      this.webpackExternals = (0, _toConsumableArray2["default"])(new Set(webpackExternals || []));
      curModule.init(compDependencies, webpackExternals, compFunc);
      this.installPages[pageId] = curModule;
    }
  }, {
    key: "getInfo",
    value: function getInfo(pageId) {
      if (!this.installPages[pageId]) {
        _logger["default"].error("%c wujiComp component[".concat(pageId, "] register failed!"), 'color: red;');
        return null;
      }
      var compInfo = this.installPages[pageId].compInfo;
      return compInfo;
    }
  }, {
    key: "getCompDependencies",
    value: function getCompDependencies(pageId) {
      if (!this.installPages[pageId]) {
        _logger["default"].error("%c wujiComp component[".concat(pageId, "] register failed!"), 'color: red;');
        return null;
      }
      return this.installPages[pageId].compDependencies;
    }
  }]);
  return PageManage;
}();
var _default = PageManage;
exports["default"] = _default;